import type { CompanyFilters } from '../types/company'

/** Default org scope: Liberty → org 1; company/regional roles → session org. */
export function getDefaultCompanyListOrgId(
    isLibertyRole: boolean,
    roleOrgId: number | string | null | undefined,
): number | string {
    return isLibertyRole ? 1 : (roleOrgId || '')
}

/** Default status filter: Liberty → Active; company roles → All (Angular parity). */
export function getDefaultCompanyListListed(isLibertyRole: boolean): string {
    return isLibertyRole ? '1' : ''
}

/** Force non-Liberty users to their session org; ignores tampered session/API overrides. */
export function applyCompanyRoleOrgScope(
    filters: CompanyFilters,
    isLibertyRole: boolean,
    roleOrgId: number | string | null | undefined,
): CompanyFilters {
    if (isLibertyRole || roleOrgId == null || roleOrgId === '') {
        return filters
    }
    return { ...filters, org_id: roleOrgId }
}
